window.VH = window.VH === undefined ? {} : window.VH;
let sendFile = function (answer) {
  $('#ajaxModal').modal('hide');

  let anchor = document.createElement('a');

  anchor.download = answer.filename;
  anchor.href = `data:${answer.mime};base64,${answer.content}`;
  anchor.target = '_blank';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

VH.AjaxModalForm = {
  init: function init() {
    $('#ajaxModal').on('submit', '.ajaxModalForm', function (e) {
      e.preventDefault();
      let form = $(this);

      $.post(
        form.attr('action'),
        form.serialize(),
        function (answer) {
          if (answer === 'OK') {
            form.closest('.modal-body').html('Ok');
            location.reload();
          }
          else {
            switch (typeof answer) {
              case 'string':
                form.closest('.modal-body').html(answer);
                break;

              case 'object':
                if ('undefined' !== typeof answer.mime) {
                  sendFile(answer);
                }
                break;

              default:
                break;
            }
          }
        },
      );

      return false;
    });
  },
};
